import { getAxiosClient } from "../axios";

export const getProducts = async (params) => {
  const axiosClient = await getAxiosClient();
  return await axiosClient
    .get(`/products`, { params: {...params}} )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};

export const getOrganizationProducts = async (slug, params) => {
  const axiosClient = await getAxiosClient();
  return await axiosClient
    .get(`/organizations/${slug}/products`, { params: {...params}} )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};